import {Component} from './component';

/**
 * File Upload Trigger Component
 * Handles clicks on import/replace file buttons
 */
export class FileUploadTrigger extends Component {

    setup() {
        this.action = this.$opts.action;
        this.entityType = this.$opts.entityType;
        this.entityId = this.$opts.entityId;

        this.$el.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
        event.preventDefault();

        const fileUploadModal = window.$components.first('file-upload-modal');
        if (!fileUploadModal) {
            console.error('FileUploadModal component not found');
            return;
        }

        fileUploadModal.show(this.action, this.entityType, this.entityId);
    }
}
